import Dropdown, { DEFAULT_OPTIONS } from 'CoreComponents/dropdown';

document.querySelectorAll(DEFAULT_OPTIONS['selector']).forEach(dropdown => {
  new Dropdown(dropdown);
});
